export function formatErrorDescription(description: string) {
  try {
    return Object.entries(JSON.parse(description))
      .map(([key, value]) => `${key} = ${value}`)
      .join(',\n');
  } catch {
    return description;
  }
}
